<template>
  <div>
    <a-form-model :rules="rules" ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <!-- <a-row>
        <a-col span="10">
          <a-form-model-item :label="$t('message.txtManagement.userPlace')" :label-col="{span:13}" :wrapper-col="{span:11}">
            #{user}
          </a-form-model-item>
        </a-col>
        <a-col span="14">
          <a-form-model-item :label="$t('message.txtManagement.couponPlace')" :label-col="{span:12}" :wrapper-col="{span:12}">
            #{coupon}
          </a-form-model-item>
        </a-col>
      </a-row> -->
      <a-form-model-item :label="$t('message.txtManagement.tableTitle2')" prop="content_name">
        <a-input :size="$globalSize" v-model="form.content_name"
          :placeholder="$t('message.txtManagement.tableTitle2')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('message.txtManagement.content')" prop="content">
        <div style="position: relative">
          <!-- <a-button  :size="$globalSize" 
              style="width: 120px;margin-bottom: 10px;position: absolute;bottom:5px;right: 10px;z-index: 2;border-radius: 8px;color: #bbbbbb"
              @click="$refs.selectTextModalRef.showModal()">
            <a-icon type="plus"></a-icon>
            文案库选择
          </a-button> -->
          <a-textarea :size="$globalSize" v-model="form.content" :rows="6" style="resize: none" />
        </div>
      </a-form-model-item>
      <!-- <a-form-model-item label="跳转链接" prop="link">
        <a-input :size="$globalSize" v-model="form.link" placeholder="请输入链接"/>
      </a-form-model-item> -->
    </a-form-model>
    <text-library-select-modal ref="selectTextModalRef" @changeCopyWrite="syncText"></text-library-select-modal>
  </div>
</template>

<script>
import utils from "@/utils";
import textLibrarySelectModal from "@/views/material/components/textLibrarySelectModal";

export default {
  name: "SmsAndAppPushTemp",
  components: {
    textLibrarySelectModal
  },
  inject: {
    parent: {
      from: 'parent'
    },
    changePreviewItem: {
      from: 'changePreviewItem',
      default: () => { }
    }
  },
  props: {
    channel: String
  },
  data() {
    return {
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 6 : 5
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 16 : 16
      },
      form: {
        content_name: '',
        content: '',
        content: '',
        app_push_title: '',
        app_push_content_target_name: ''
      },
      channelKey: this.channel,
      rules: {
        content_name: [{ required: true, message: this.$t('message.strategyStore.pleaseEnterName'), trigger: 'blur' }],
        content: [{ required: true, message: this.$t('message.strategyStore.pleaseEnterContent'), trigger: 'blur' }],
      }
    }
  },
  watch: {
    channel(v) {
      this.channelKey = v
    },
    form: {
      handler(v) {
        this.changePreviewItem && this.changePreviewItem({ type: this.channelKey, detail: v.content })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    syncText(v) {
      this.form.content = v
    },
     formValidate() {
      let data
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate( valid => {
          if (!valid) {
            reject(new Error('form  error '))
            return
          }
          data = { ...this.form }
          resolve({ ...data })
        })
      })
    }
  },
  mounted() {
    utils.languageChange(this, { labelCol: 8, wrapperCol: 16 }, { labelCol: 6, wrapperCol: 16 })
    if (this.parent.currentItem) {
      this.form = { ...this.parent.currentItem }
      console.log(this.form)
    }
  },
  beforeDestroy() {
    this.$refs.ruleForm.resetFields()
  }
}
</script>

<style scoped></style>